import { Box } from '@mui/material';
import { DataGrid, GridColDef, GridRenderCellParams, GridRowsProp, useGridApiRef } from '@mui/x-data-grid';
import React from 'react';
import CustomNoRowsOverlay from '../../../../Common/CustomNoRowsOverlay';
import { formatNumber } from '../../../../Common/FormatNumber';

interface ChartProps {
    title: string;
    id: number;
    height: number;
}

export default function Returns({ title, id, height = 345 }: ChartProps) {
    const apiRef = useGridApiRef();
    const [loading, setLoading] = React.useState(true);
    const [rows, setRows] = React.useState<GridRowsProp>([]);

    const columns: GridColDef[] = [
        { field: 'id', headerName: 'ID', width: 100, headerAlign: 'center', align: 'center' },
        { field: 'name', headerName: 'Product Group', width: 150, headerAlign: 'center', align: 'center', type: 'string' },
        { field: 'entity_product_id', headerName: 'Entity Product ID', width: 150, headerAlign: 'center', align: 'center' },
        { field: 'invoice_nbr', headerName: 'Invoice #', width: 150, headerAlign: 'center', align: 'center', type: 'string' },
        { field: 'invoice_dt', headerName: 'Invoice Date', width: 150, headerAlign: 'center', align: 'center', type: 'string'},
        { field: 'bill_qty', headerName: 'Qty', width: 80, headerAlign: 'center', align: 'center', type: 'number' },
        { field: 'sales_amt', headerName: 'Sales', width: 100, headerAlign: 'center', align: 'center', type: 'number',
            renderCell: (params: GridRenderCellParams) => {
                return <span>{formatNumber(params.value)}</span>;
            },
        },
    ];

    React.useEffect(() => {
        fetch(`/dashboard/customer-returns/${id}/?entity_id=${localStorage.getItem('entity_id')}`)
        .then(response => response.json())
        .then(data => {
            setRows(data.rows);
            setLoading(false);
        });
    }, []);

    return (
        <Box sx={{ height: '100%', width: '100%', flexDirection: 'row', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <DataGrid
                showToolbar
                loading={loading}
                apiRef={apiRef}
                columns={columns}
                rows={rows}
                pagination
                initialState={{ pagination: { paginationModel: { pageSize: 20, page: 0 }, rowCount: 0 } }}
                pageSizeOptions={[5, 10, 20, 50, 100]}
                sx={{ height: height, width: '100%' }}
                slots={{
                    noRowsOverlay: () => <CustomNoRowsOverlay message="No returns found" />
                }}
            />
        </Box>
    );
}


// import { Box, Typography } from '@mui/material';
// import Highcharts from 'highcharts';
// import HighchartsReact from 'highcharts-react-official';
// import 'highcharts/highcharts-more';
// import 'highcharts/modules/solid-gauge';
// import React from 'react';

// interface ChartProps {
//     title: string;
//     id: number;
//     height: number;
// }

// export default function Returns({ title, id, height = 345 }: ChartProps) {

//     const [numberReturns, setNumberReturns] = React.useState(0);
//     const [numberReturnsMax, setNumberReturnsMax] = React.useState(0);
//     const [valueReturns, setValueReturns] = React.useState(0);
//     const [valueReturnsMax, setValueReturnsMax] = React.useState(0);
//     const chartComponentRef = React.useRef<HighchartsReact.RefObject>(null);
//     React.useEffect(() => {
//         fetch(`/dashboard/returns/${id}/?entity_id=${localStorage.getItem('entity_id')}`)
//         .then(response => response.json())
//         .then(data => {
//             setNumberReturns(data.number_returns);
//             setValueReturns(data.value_returns);
//             setValueReturnsMax(data.value_returns_max);
//             setNumberReturnsMax(data.number_returns_max);
//         }
//         );
//     }, []);

//     const gaugeOptions: Highcharts.Options = {
//         chart: {
//             type: 'solidgauge'
//         },
    
//         title: null,
    
//         pane: {
//             center: ['50%', '85%'],
//             size: '90%',
//             startAngle: -90,
//             endAngle: 90,
//             background: [{
//                 outerRadius: '100%',
//                 innerRadius: '60%',
//                 backgroundColor: Highcharts.color('#EEE').setOpacity(0.3).get(), // or just '#EEE' as fallback
//                 shape: 'arc'
//             }]
//         },
    
//         exporting: {
//             enabled: false
//         },
    
//         tooltip: {
//             enabled: false
//         },
    
//         // the value axis
//         yAxis: {
//             stops: [
//                 [0.1, '#55BF3B'], // green
//                 [0.5, '#DDDF0D'], // yellow
//                 [0.9, '#DF5353'] // red
//             ],
//             lineWidth: 0,
//             tickWidth: 0,
//             minorTickInterval: null,
//             tickAmount: 2,
//             title: {
//                 y: -100,
//                 text: 'Number of Returns',
//                 style: {
//                     fontSize: '16px',
//                     fontFamily: 'Trebuchet MS'
//                 }
//             },
//             labels: {
//                 y: 16,
//                 style: {
//                     fontSize: '16px',
//                     fontFamily: 'Trebuchet MS'
//                 }
//             },
//             min: 0,
//             max: numberReturnsMax
//         },
    
//         plotOptions: {
//             solidgauge: {
//                 borderRadius: 3,
//                 dataLabels: {
//                     y: 5,
//                     borderWidth: 0
//                 }
//             }
//         },

//         credits: {
//             enabled: false
//         },

//         series: [{
//             name: 'Number of Returns',
//             data: [numberReturns],
//             type: 'solidgauge',
//             dataLabels: {   
//                 format: '<div style="text-align:center">' +
//                 '<span style="font-size:20px;opacity:0.5;font-family:Trebuchet MS">{y}</span></div>'
//             }
//         }]

//     };

//     const valueReturnsOptions: Highcharts.Options = {
//         chart: {
//             type: 'solidgauge'
//         },
    
//         title: null,
    
//         pane: {
//             center: ['50%', '85%'],
//             size: '90%',
//             startAngle: -90,
//             endAngle: 90,
//             background: [{
//                 outerRadius: '100%',
//                 innerRadius: '60%',
//                 backgroundColor: Highcharts.color('#EEE').setOpacity(0.3).get(), // or just '#EEE' as fallback
//                 shape: 'arc'
//             }]
//         },
    
//         exporting: {
//             enabled: false
//         },
    
//         tooltip: {
//             enabled: false
//         },
    
//         // the value axis
//         yAxis: {
//             stops: [
//                 [0.1, '#55BF3B'], // green
//                 [0.5, '#DDDF0D'], // yellow
//                 [0.9, '#DF5353'] // red
//             ],
//             lineWidth: 0,
//             tickWidth: 0,
//             minorTickInterval: null,
//             tickAmount: 2,
//             title: {
//                 y: -100,
//                 text: 'Value of Returns',
//                 style: {
//                     fontSize: '16px',
//                     fontFamily: 'Trebuchet MS'
//                 }
//             },
//             labels: {
//                 y: 16,
//                 style: {
//                     fontSize: '16px',
//                     fontFamily: 'Trebuchet MS'
//                 }
//             },
//             min: 0,
//             max: valueReturnsMax
//         },
    
//         plotOptions: {
//             solidgauge: {
//                 borderRadius: 3,
//                 dataLabels: {
//                     y: 5,
//                     borderWidth: 0
//                 }
//             }
//         },

//         credits: {
//             enabled: false
//         },

//         series: [{
//             name: 'Value of Returns',
//             data: [valueReturns],
//             type: 'solidgauge',
//             dataLabels: {   
//                 format: '<div style="text-align:center">' +
//                 '<span style="font-size:20px;opacity:0.5;font-family:Trebuchet MS">${y:,.2f}</span></div>'
//             }
//         }]

//     };
    
//     return (
//         <div style={{ height: '100%', width: '100%' }}>
//             {numberReturns > 0 && valueReturns > 0 ? (
//                 <Box sx={{ display: 'flex', flexDirection: 'row', gap: 0 }}>
//                     <HighchartsReact
//                         highcharts={Highcharts as any}
//                         options={gaugeOptions}
//                         allowChartUpdate={true}
//                         exportEnabled={true}
//                         ref={chartComponentRef}
//                         containerProps={{ style: { width: '50%', height: height, borderTopLeftRadius: '5px', borderBottomLeftRadius: '5px', boxShadow: 'none', margin: 0, padding: 0 } }}
//                     />
//                     <HighchartsReact
//                         highcharts={Highcharts as any}
//                         options={valueReturnsOptions}
//                         allowChartUpdate={true}
//                         exportEnabled={true}
//                         ref={chartComponentRef}
//                         containerProps={{ style: { width: '50%', height: height, borderTopRightRadius: '5px', borderBottomRightRadius: '5px', boxShadow: 'none', margin: 0, padding: 0 } }}
//                     />
//                 </Box>
//             ) : (
//                 <Typography variant="body1" sx={{ color: 'text.secondary', textAlign: 'center' }}>No data available</Typography>
//             )}
//         </div>
//     );
// }